/*global diy, jimdoData*/
'use strict';

import $ = require('jquery');
import features = require('diy/util/features');
import {getString as l10n} from 'diy/util/l10n';
import websiteData = require('diy/util/websiteData');
import infoDialogApi = require('diy/info-dialog/InfoDialogApi');
import WebcomponentUpsellApi from 'diy/app-upsell/webcomponentUpsell';
import AutoLayerManager from "../autolayermanager/AutoLayerManager";
import NotificationPoller from 'diy/toolbar/notificationNG/Poller';

interface Options {
    getContentCallback: (index: number, oldHtml: string) => string;
    class: string;
    width: number;
    title: string;
}

interface UpsellTariffAbTestPayload {
    variant: string;
}

interface OpenedFrom {
    component: string;
    webComponentId?: string;
    control?: string;
}

interface RequestBody {
    "status-code": "PROCESSING";
    webComponentId: string;
}

/**
 * reference to the automatic layer manager
 */
let layerManager: AutoLayerManager;
/**
 * reference for the dialog
 */
let teaserDialog: JQuery;

/**
 * classes that the dialog will receive
 */
let dialogClassBase = 'update-tariff-modal cp-style';
/**
 * @type Object
 */
let activeOptions: Options = null;
/**
 * options for different types of screens (upgrade, success, error).
 * Used in dialog creation and update
 * @type Object containing Objects with keys: width (int), title (String),
 * getContentCallback (Function) and class (String, optional)
 */
let options = {
    orderfinalized: {
        'width': 750,
        'title': l10n('tariffupdate.orderfinalized.title'),
        'getContentCallback': getOrderFinalizedContent,
        'class': 'orderfinalized-dialog'
    }
};

let currentPageName = 'upgrade';

let pollingInterval     = 20 * 1000; // 20 seconds
let errorMaximumRetries = 5;
let errorCountRetries   = 0;
let orderIsFinalized    = false;

/**
 * dialog close handler
 */
let sourceClose: string;

/**
 * List of supported order action value patterns during shop update processes
 *
 * @link http://maven-sites.server.lan/ciso/com.oneandone.sales.middleware/popupshop/index.html
 */
let orderActionPatterns = [/popupshop.close/, /popupshop.goToProduct/];

/**
 * List of supported order status value patterns during shop update processes
 *
 * @link http://maven-sites.server.lan/ciso/com.oneandone.sales.middleware/popupshop/index.html
 */
let orderStatusPatterns = [
    /NOT_ORDERED/,
    /OK/,
    /ALREADY_ACTIVE/,
    /MISSING_ITEM/,
    /LOCKED/,
    /BLOCKED/,
    /ERROR/
];

let trackingEventTypes = {
    'opened': 'opened',
    'closed': 'closed',
    'ordered': 'ordered',
    'succeeded': 'succeeded',
    'error': 'error'
};

let tariffTrackingEvents: {[name: string]: string} = {
    'opened': 'diy-editor-tariffupgrade-upgradedialog',
    'closed': 'diy-editor-tariffupgrade-closedialog',
    'error': 'diy-editor-tariffupgrade-errordialog'
};

let microBKShopTrackingEvents: {[name: string]: string} = {
    'opened': 'diy-editor-microbkshop-openeddialog',
    'closed': 'diy-editor-microbkshop-closeddialog',
    'ordered': 'diy-editor-microbkshop-ordereddialog',
    'succeeded': 'diy-editor-microbkshop-successdialog',
    'error': 'diy-editor-microbkshop-errordialog'
};

function setLayerManager(lm: AutoLayerManager) {
    layerManager = lm;
}

/**
 * ///////
 * Congratulations message (Moments to celebrate)
 * ///////
 */
function welcomeToPlus() {
    teaserDialog.diy_dialog('option', 'close', function() {
        onClose();
        layerManager.unblockAndProcessQueue();
    });
    teaserDialog.diy_dialog('option', 'open', function() {
        onOpen();
        $.ajax({
            url: '/app/siteadmin/tariffupdate/acknowledgetariffupdate',
            type: 'GET',
            data: { cstok: jimdoData.cstok }
        });
        // KPI tracking
        track('diy-editor-tariffupgrade-congratulationsdialog', {});
        currentPageName = 'congratulations';
    });
    teaserDialog.diy_dialog("option", "closeButton", false);
    teaserDialog.diy_dialog('open');
}

/**
 * Congratulations dialog content
 * @returns {*|HTMLElement}
 */
function getWelcomeToPlusContent() {
    let html = '<div>';
    html +=     '<div class="welcometoplus-container">';
    html +=         '<div>';
    html +=             '<img class="welcometoplus-visual" src="' + websiteData.getCdnUrl() +
        's/diy/tariffupdate/img/welcome_to_plus.png" alt="" />';
    html +=         '</div>';
    html +=         '<div class="welcometoplus-message">' +
        l10n('tariffupdate.welcometoplus.primarymessage') +
        '</div>';
    html +=     '</div>';
    html +=     '<div class="welcometoplus-features">';
    html +=         '<div class="welcometoplus-featuresmessage">' +
        l10n('tariffupdate.welcometoplus.secondarymessage') +
        '</div>';
    html +=         '<div class="welcometoplus-featurebuttons">';
    html +=             '<button class="pages-button">' +
        l10n('tariffupdate.welcometoplus.pages') +
        '</button>';
    html +=             '<button class="apps-button">' +
        l10n('tariffupdate.welcometoplus.apps') +
        '</button>';
    html +=             '<button class="widget-button">' +
        l10n('tariffupdate.welcometoplus.widget') +
        '</button>';
    html +=         '</div>';
    html +=     '</div>';
    html +=     '<div class="cp-style">';
    html +=         '<div class="welcometoplus-close-wrapper">';
    html +=             '<button class="blue-primary">' + l10n('tariffupdate.success.close') + '</button>';
    html +=         '</div>';
    html +=     '</div>';
    html += '</div>';

    let $html = $(html);

    $html.find('button:last')
        .button()
        .bind('click', function() {
            teaserDialog.diy_dialog('close');
        });

    $html.find('button.pages-button').bind('click', function() {
        sourceClose = 'pages_click';
        $("#cc-sa-item-pages").click();
        teaserDialog.diy_dialog('close');
    });
    $html.find('button.apps-button').bind('click', function() {
        sourceClose = 'apps_click';
        $("#cc-sa-item-appscatalog").click();
        teaserDialog.diy_dialog('close');
    });
    $html.find('button.widget-button').bind('click', function() {
        sourceClose = 'widget_click';
        $("#cc-sa-item-elements").click();
        teaserDialog.diy_dialog('close');
    });

    return $html.html();
}

function deleteNewRibbonFeature(featurename: string) {
    $.get('/app/siteadmin/tariffupdate/deleteribbon/?fn=' + featurename);
}

function deleteElementNewFeatureRibbon() {
    deleteNewRibbonFeature('elements');
    $(".cc-sa-sidebar-this_is_new", "#cc-sa-item-elements").remove();
}

function deletePagesNewFeatureRibbon() {
    deleteNewRibbonFeature('pages');
    $(".cc-sa-sidebar-this_is_new", "#cc-sa-item-pages ").remove();
}

function deleteAppsNewFeatureRibbon() {
    deleteNewRibbonFeature('apps');
    $(".cc-sa-sidebar-this_is_new", "#cc-sa-item-appscatalog").remove();
}

/**
 * This method creates an diy_dialog for the upgrade tariff and stores the reference
 * in the instance variable teaserDialog
 */
function createTeaserDialog(opts: Options) {
    teaserDialog = $('#updateTariffModal');
    if (teaserDialog.length > 0) {
        return;
    }
    teaserDialog = $('<div id="updateTariffModal"></div>')
        .html(opts.getContentCallback);
    teaserDialog.diy_dialog({
        "dialogClass": dialogClassBase + (opts.class ? " " + opts.class : ""),
        "overlayCls": 'black-overlay',
        "closeButton": true,
        "closeCls": 'ui-icon-24 ui-icon-24-xclose',
        "modal": true,
        "autoOpen": false,
        "width": opts.width,
        "maxHeight": $(window).innerHeight(),
        "draggable": false,
        "resizable": false,
        "closeOnEscape": false,
        "close": onClose,
        "open": onOpen,
        "title": opts.title,
        "helpButton": false
    }).diy_dialog('getWrapperElement').css({
        'z-index': diy.editor.getNewTopZIndex(undefined, 'blockingModals'),
        position: 'relative'
    });

    activeOptions = opts;
}

/**
 * dialog open handler
 */
function onOpen() {
    $(window).on('resize', fullViewCallback);
    $(window).on('orientationchange', fullViewCallback);
}
function onClose() {
    $('#cc-sa-item-updateTariff').removeClass('cc-sa-active');
    $(window).off('resize', fullViewCallback);
    $(window).off('orientationchange', fullViewCallback);
    let actionName = 'close';
    if (sourceClose) {
        actionName += '_' + sourceClose;
        sourceClose = null;
    }
    track('diy-editor-tariffupgrade-closedialog', {
        'actionName': actionName,
        'pageName': currentPageName
    });
}

/**
 * This method changes content and some properties of the dialog, allowing to switch between
 * upgrade screen and success / error messages
 */
function updateTeaserDialog(opts: Options) {
    if (!teaserDialog) {
        createTeaserDialog(opts);
    } else {
        let dialogClass = dialogClassBase;
        if (opts.class) {
            dialogClass = dialogClassBase + " " + opts.class;
        }
        teaserDialog.diy_dialog('option', 'dialogClass', dialogClassBase + (opts.class ? " " + opts.class : ""));
        teaserDialog.html(opts.getContentCallback);
        teaserDialog.diy_dialog('option', 'title', opts.title);
        teaserDialog.diy_dialog('option', 'width', opts.width);

        teaserDialog.diy_dialog("option", "position", {my: "center", at: "center", of: window});
    }
    activeOptions = opts;
    fullViewCallback();
}

function switchFullView() {
    if (!teaserDialog) {
        return;
    }
    teaserDialog.diy_dialog('option', 'width', '100%');
    teaserDialog.addClass('full-view');
}

function switchNormalView() {
    if (!teaserDialog) {
        return;
    }
    teaserDialog.removeClass('full-view');
    teaserDialog.diy_dialog('option', 'width', activeOptions.width);
}

function shouldShowFullView() {
    return ($(window).innerHeight() < 640 || $(window).innerWidth() < 648);
}

function fullViewCallback() {
    teaserDialog.diy_dialog("option", "position", {my: "center", at: "center", of: window});
    shouldShowFullView() ? switchFullView() : switchNormalView();
}

let orderIsPlaced: boolean;
function isOrderPlaced() {
    if (orderIsPlaced === undefined) {
        $.ajax({
            url: '/app/siteadmin/tariffupdate/triggerorderplacedactions',
            type: 'GET',
            data: { cstok: jimdoData.cstok },
            "success": function(response) {
                orderIsPlaced = (true === response.data.triggerOrderPlacedActions);
                if (orderIsPlaced) {
                    setTimeout(updateStatusRequest, pollingInterval);
                }
            }
        });
    }
    return orderIsPlaced || false;
}

/**
 * constructs the html for the order finalized dialog content
 * @returns html string
 */
function getOrderFinalizedContent() {
    let html = '<div>';
    html +=     '<div class="order-finalized-container">';
    html +=         '<div>';
    html +=             '<img class="order-finalized-visual" src="' + websiteData.getCdnUrl() +
        's/diy/tariffupdate/img/order_finalized_visual.png" alt="" />';
    html +=         '</div>';
    html +=         '<div class="order-finalized-message">' +
        l10n('tariffupdate.orderfinalized.primarymessage') +
        '</div>';
    html +=     '</div>';
    html +=     '<div class="cp-style">';
    html +=         '<div class="order-finalized-close-wrapper">';
    html +=             '<button class="reload blue-primary">' + l10n('tariffupdate.orderfinalized.reload') +
        '</button>';
    html +=             '<button class="continue blue-secondary">' + l10n('tariffupdate.orderfinalized.continue') +
        '</button>';
    html +=         '</div>';
    html +=     '</div>';
    html += '</div>';

    let $html = $(html);

    $html.find('button').button();
    $html.find('button.reload').bind('click', function() {
        track('diy-editor-tariffupgrade-reloadpage', {});
        document.location.reload();
    });
    $html.find('button.continue').bind('click', function() {
        sourceClose = 'continue';
        teaserDialog.diy_dialog('close');
    });

    return $html.html();
}

function updateStatusRequest() {
    $.ajax({
        url: '/app/siteadmin/tariffupdate/pollstatus',
        type: 'GET',
        data: { cstok: jimdoData.cstok },

        "success": function(response) {
            let data = response.data;
            if (data.hasOwnProperty("orderfinalized") && true === data.orderfinalized) {
                /**
                 * much success. very refresh. such update
                 */
                orderIsFinalized = true;
                layerManager.enqueue({
                    priority: 1,
                    callback: openOrderFinalizedDialog
                });
            } else {
                /**
                 * Not there yet ... keep asking though
                 */
                setTimeout(updateStatusRequest, pollingInterval);
            }
        },

        "error": function(response) {
            //disable default black error message
            response.disableBlackBoxVisualError = true;
            /**
             * What hapenned ? Is this normal ? Maybe we should stop polling, at least for a while...
             */
            if (errorCountRetries < errorMaximumRetries) {
                setTimeout(updateStatusRequest, pollingInterval * 10);
            } else {
                errorCountRetries++;
            }
        }

    });
}

function openOrderFinalizedDialog() {
    updateTeaserDialog(options.orderfinalized);
    teaserDialog.diy_dialog("option", "closeButton", false);
    teaserDialog.diy_dialog('open');
    // KPI tracking
    track('diy-editor-tariffupgrade-finalizeddialog', {});
    currentPageName = 'finalized';
}

function track(event: string, data: {}) {
    $(document).trigger(event, data);
}

/**
 *
 *
 */
function init() {
    if (features('updateTariffNewRibbons')) {
        $(document).ready(function() {
            $(document).on("moduleSelectorInitialized", deleteElementNewFeatureRibbon);
            $(document).on("diy-managepages-show", deletePagesNewFeatureRibbon);
            $(document).on("diy-editor-appCatalog-loadComplete", deleteAppsNewFeatureRibbon);
        });
    }

    //disable component if feature flag is off
    if (features('updateTariff')) {
        /**
         * When we're ready loading the DOM we can create the dialog
         * I've chosen to do this and not at first open
         * because in the last situation it seems not to be properly centered
         */
        $(document).ready(function() {
            if (isOrderPlaced()) {
                setTimeout(updateStatusRequest, pollingInterval);
            }
        });

        /**
         * Listener for the siteadmin control
         */
        $(document).on("mousedown", "#cc-sa-item-updateTariff", function() {
            let component = "siteAdmin";
            if (features('upsellTariffAbTest')) {
                let buttonTop = ('VARIANT_A' ===
                    features.getPayload<UpsellTariffAbTestPayload>('upsellTariffAbTest').variant);
                $(document).trigger('diy-editor-generic-sectionAccessed', {
                    sectionCodeName: "updateTariff",
                    trackingParams: {
                        'prop12': (buttonTop ? 'UpsellButtonTop' : 'UpsellButtonBottom')
                    }
                });
                if (buttonTop) {
                    component = "siteAdminTop";
                }
            }
            openPopupShop({component: component});
        });

        /**
         * Listener for the pagelimitation controls
         */
        $(document).on("click", ".openUpdateTariffTeaser", function() {
            openPopupShop({component: "pageLimitation"});
            return false; //prevent event propagation
        });
    }
}

function openPopupShop(openedFrom: OpenedFrom) {
    let requestParams = getUpdateRequestParams(openedFrom);

    $.get('/app/siteadmin/tariffupdate/getshoplink', requestParams)
        .then(function(response) {
                let data = response.data;
                if (typeof  data !== 'undefined' && data.hasOwnProperty('link')) {
                    createPopup(openedFrom, data.link);
                } else {
                    throw 'could not fetch shop link from backend';
                }
            }
        ).fail(
            function(response) {
                throw response.responseText;
            }
        );
}

function triggerSuccessDialog(webComponentId: string, callback: () => any) {
    if (typeof webComponentId !== "undefined") {

        infoDialogApi.showDialog(
            {
                title: l10n('tariffupdate.success.title.' + webComponentId),
                description: l10n('tariffupdate.success.description.' + webComponentId),
                image: websiteData.getCdnUrl() + 's/diy/site-admin/main/img/upsell/' + webComponentId + '-success.png',
                imageHeight: 310,

                secondaryButtonConfig: {
                    'label': l10n('tariffupdate.success.close'),
                    'callback': () => {
                        $(document).trigger(
                            "diy-editor-generic-linkInteraction",
                            {
                                pageName: "MyShopReady",
                                actionName: "close"
                            }
                        );
                        if (typeof callback === "function") {
                            callback();
                        }
                    }
                }
            }
        );

        trackByComponent(
            'webComponentUpSell',
            trackingEventTypes.succeeded,
            {
                'actionName': 'succeeded',
                'pageName': 'upgrade',
                'channel': webComponentId + 'Upsell'
            }
        );
    }
}

function triggerPollingInNotification(webComponentId: string) {
    if (features("notificationsNG")) {
        NotificationPoller.start();
    } else {
        let webcomponentUpsellApi = new WebcomponentUpsellApi;

        webcomponentUpsellApi.setApi((<any>diy).editor.notifications.api);
        webcomponentUpsellApi.startPolling(webComponentId);
    }
}

function triggerWebComponentUpSell(requestBody: RequestBody) {
    let urlPattern = '/rest/websites/{ID}/webcomponent-upsell';
    let requestUrl = urlPattern.replace('{ID}', websiteData.getId());

    $.ajax({
        url: requestUrl,
        type: 'POST',
        contentType: 'application/vnd.oneandone.diy.website.webcomponent-upsell+json',
        processData: false,
        dataType: 'json',
        data: JSON.stringify(requestBody),
        error: function(response) {
            throw response.responseText;
        }
    });
}

function createPopup(openedFrom: OpenedFrom, link: string) {
    let overlayContainer = $('#popupshopOverlay');

    if (overlayContainer.length === 0) {
        overlayContainer = $('<div class="diye"><div id="popupshopOverlay"></div></div>')
            .appendTo('body');
        overlayContainer.css({
            height: $(window.document).height() + 'px',
            left: '0', top: '0', position: 'absolute', width: '100%',
            'background-color': 'rgba(0,0,0,0.5)', 'z-index': 120000
        });
    } else {
        // overlay is already open, prevent opening it twice
        return;
    }

    let html = '<div class="update-tariff-popupshop"><iframe src="' + link + '" /></div>';

    overlayContainer.append(html);

    // make sure the popup is in viewport, even if page is scrolled
    overlayContainer.find('.update-tariff-popupshop').css({
        top: $(window).scrollTop() + 'px'
    });

    // KPI tracking for opening dialog
    trackOpeningEventByComponent(openedFrom);

    let onSuccessStatusForTariffUpdate = function() {
        setTimeout(updateStatusRequest, pollingInterval);
    };

    let onErrorStatusForTariffUpdate = function() {
        trackByComponent(
            'tariffUpdate',
            trackingEventTypes.error,
            {'actionName': 'error', 'pageName': 'error'}
        );
    };

    let onCloseForTariffUpdate = function() {
        closePopup();
        window.removeEventListener("message", tariffUpDateMessage, false);

        trackByComponent(
            'tariffUpdate',
            trackingEventTypes.closed,
            {'actionName': 'close', 'pageName': 'upgrade'}
        );
    };

    let onSuccessForWebComponentUpSell = function() {
        triggerWebComponentUpSell({
            "status-code": "PROCESSING",
            "webComponentId": openedFrom.webComponentId
        });

        triggerSuccessDialog(
            openedFrom.webComponentId,
            function () {
                triggerPollingInNotification(openedFrom.webComponentId);
            }
        );

        trackByComponent(
            'webComponentUpSell',
            trackingEventTypes.ordered,
            {
                'actionName': 'ordered',
                'pageName': 'upgrade',
                'channel': openedFrom.webComponentId + 'Upsell'
            }
        );

        closePopup();
    };

    let onErrorStatusForWebComponentUpSell = function() {
        trackByComponent(
            'webComponentUpSell',
            trackingEventTypes.error,
            {'actionName': 'error', 'pageName': 'error'}
        );
    };

    let onCloseForWebComponentUpSell = function() {
        closePopup();
        window.removeEventListener("message", webComponentUpSellMessage, false);

        trackByComponent(
            'webComponentUpSell',
            trackingEventTypes.closed,
            {
                'actionName': 'close',
                'pageName': 'upgrade',
                'channel': openedFrom.webComponentId + 'Upsell'
            }
        );
    };

    function closePopup() {
        overlayContainer.remove();
        overlayContainer = null;
    };

    let tariffUpdateCallBacks = {
        "OK": onSuccessStatusForTariffUpdate,
        "popupshop.close": onCloseForTariffUpdate,
        "ERROR": onErrorStatusForTariffUpdate
    };

    let webComponentUpSellCallBacks = {
        "OK": onSuccessForWebComponentUpSell,
        "NOT_ORDERED": onCloseForWebComponentUpSell,
        "ERROR": onErrorStatusForWebComponentUpSell
    };

    function tariffUpDateMessage(event: MessageEvent) {
        messageHandler(event, tariffUpdateCallBacks);
    };

    function webComponentUpSellMessage(event: MessageEvent) {
        messageHandler(event, webComponentUpSellCallBacks);
    };

    function messageHandler(event: MessageEvent, callBacks: any) {
        let message = null;
        if (event.data.orderProcess) {
            message = event.data.orderProcess;
        } else if (event.data) {
            message = event.data;
        }
        let action = getValueByPattern(orderActionPatterns, message);
        let status = getValueByPattern(orderStatusPatterns, message);

        let statusCallBack: any = callBacks[status];
        let actionCallBack: any = callBacks[action];

        //handle order status
        if (typeof statusCallBack === 'function') {
            statusCallBack();
        }

        //handle order action
        if (typeof actionCallBack === 'function') {
            actionCallBack();
        }
    };

    let messageListeners: {[key: string]: (e: MessageEvent) => void} = {
        'tariffUpDate': tariffUpDateMessage,
        'webComponentUpSell': webComponentUpSellMessage
    };

    initMessageListener(openedFrom.component, messageListeners);
}

/**
 * Retrieves Update Request params
 */
function getUpdateRequestParams(openedFrom: OpenedFrom) {
    let requestParams: {
        shopType: string;
        trackingTarget: string;
        webComponentId?: string;
    } = null;

    switch (openedFrom.component) {
        case 'webComponentUpSell':
            requestParams = {
                shopType: "microBKShop",
                trackingTarget: openedFrom.component,
                webComponentId: openedFrom.webComponentId
            };
            break;

        default:
            requestParams = {
                shopType: "headlessShop",
                trackingTarget: openedFrom.component
            };
            break;
    }

    return requestParams;
}
/**
 * Retrieves dialog opening context for kpi tracking
 */
function getOpeningContext(openedFrom: OpenedFrom) {
    let openingContext = openedFrom.component;

    switch (openedFrom.component) {
        case 'webComponentUpSell':
            openingContext = openedFrom.webComponentId;
            break;

        default:
            if (typeof openedFrom.control !== 'undefined') {
                openingContext += '_' + openedFrom.control;
            }
            break;

    }
    return openingContext;
}

/**
 * Tracks kpi opening dialog action identified by event type
 */
function trackOpeningEventByComponent(openedFrom: OpenedFrom) {
    let data = {};
    let openingContext = getOpeningContext(openedFrom);

    switch (openedFrom.component) {
        case 'webComponentUpSell':
            data = {openingContext: openingContext, channel: openedFrom.webComponentId + 'Upsell'};
            break;

        default:
            data = {openingContext: openingContext};
            break;
    }

    trackByComponent(openedFrom.component, trackingEventTypes.opened, data);
}

/**
 * Tracks kpi actions identified by event type
 */
function trackByComponent(component: string, eventType: string, data: {}) {
    switch (component) {
        case 'webComponentUpSell':
            track(microBKShopTrackingEvents[eventType], data);
            break;

        default:
            track(tariffTrackingEvents[eventType], data);
            break;
    }
}

function initMessageListener(component: string, messageListeners: {[name: string]: (e: MessageEvent) => void}) {
    let messageListener: (e: MessageEvent) => void = null;

    switch (component) {
        case 'webComponentUpSell':
            messageListener = messageListeners['webComponentUpSell'];
            break;

        default:
            messageListener = messageListeners['tariffUpDate'];
            break;
    }

    window.addEventListener("message", messageListener, false);
}

function getValueByPattern(patterns: RegExp[], text: string): string {
    let pattern: RegExp;
    let valueByPattern: RegExpExecArray;

    if (patterns instanceof Array) {
        for (let i = 0; i < patterns.length; i++) {
            pattern = patterns[i] as RegExp;
            valueByPattern = pattern.exec(text);

            if (valueByPattern !== null) {
                return valueByPattern[0];
            }
        }
    }
    return "";
}

module.exports = {
    init: init,
    openPopup: openPopupShop,
    setLayerManager: setLayerManager
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/tariffupdate/tariffUpdate.ts
 **/